import { combineReducers } from 'redux';

import lab from './lab/reducer';
import earning from './earning/reducer';
import teleconsult from './teleconsult/reducer';
import appointment from './appointment/reducer';
import prescription from './prescription/reducer';

export default combineReducers({
  lab,
  earning,
  teleconsult,
  appointment,
  prescription,
});
